import React from 'react';
import '../CSS/StartScreen.css';
import { getBrandingValue } from '../utils/subdomainUtils';

function StartScreen({ onStart }) {
  const logoPath = getBrandingValue('logo');
  const title = getBrandingValue('title');
  const tagline = getBrandingValue('tagline');
  
  return (
    <div className="start-screen" onClick={onStart}>
      <div className="start-content">
        <div className="logo-container">
          <img 
            src={logoPath} 
            alt={`${title} Logo`} 
            className="start-logo"
          />
        </div>
        <h1 className="start-title">Welcome to {title}</h1>
        <p className="start-subtitle">{tagline}</p>
        <p className="start-instruction">Tap anywhere to begin your order</p>
        <div className="start-indicator">
          <span className="tap-icon">👆</span>
        </div>
      </div>
    </div>
  );
}

export default StartScreen; 